module.exports = __webpack_public_path__ + "media/application/images/placeholder/placeholder-8a80af8a2a00a4659f56451481afcd79.png";